module.exports = __webpack_public_path__ + "static/media/kingcake2.5592f081.jpeg";